export var StreetSuffixes;
(function (StreetSuffixes) {
    StreetSuffixes[StreetSuffixes["Central"] = 0] = "Central";
    StreetSuffixes[StreetSuffixes["Deviation"] = 1] = "Deviation";
    StreetSuffixes[StreetSuffixes["East"] = 2] = "East";
    StreetSuffixes[StreetSuffixes["Extension"] = 3] = "Extension";
    StreetSuffixes[StreetSuffixes["Lower"] = 4] = "Lower";
    StreetSuffixes[StreetSuffixes["Inner"] = 5] = "Inner";
    StreetSuffixes[StreetSuffixes["Mall"] = 6] = "Mall";
    StreetSuffixes[StreetSuffixes["North"] = 7] = "North";
    StreetSuffixes[StreetSuffixes["North East"] = 8] = "North East";
    StreetSuffixes[StreetSuffixes["North West"] = 9] = "North West";
    StreetSuffixes[StreetSuffixes["Off"] = 10] = "Off";
    StreetSuffixes[StreetSuffixes["On"] = 11] = "On";
    StreetSuffixes[StreetSuffixes["Outer"] = 12] = "Outer";
    StreetSuffixes[StreetSuffixes["Overpass"] = 13] = "Overpass";
    StreetSuffixes[StreetSuffixes["South"] = 14] = "South";
    StreetSuffixes[StreetSuffixes["South East"] = 15] = "South East";
    StreetSuffixes[StreetSuffixes["South West"] = 16] = "South West";
    StreetSuffixes[StreetSuffixes["Upper"] = 17] = "Upper";
    StreetSuffixes[StreetSuffixes["West"] = 18] = "West";
})(StreetSuffixes || (StreetSuffixes = {}));
export var StreetTypes;
(function (StreetTypes) {
    StreetTypes[StreetTypes["Access"] = 0] = "Access";
    StreetTypes[StreetTypes["Alley"] = 1] = "Alley";
    StreetTypes[StreetTypes["Alleyway"] = 2] = "Alleyway";
    StreetTypes[StreetTypes["Amble"] = 3] = "Amble";
    StreetTypes[StreetTypes["Anchorage"] = 4] = "Anchorage";
    StreetTypes[StreetTypes["Approach"] = 5] = "Approach";
    StreetTypes[StreetTypes["Arcade"] = 6] = "Arcade";
    StreetTypes[StreetTypes["Arterial"] = 7] = "Arterial";
    StreetTypes[StreetTypes["Artery"] = 8] = "Artery";
    StreetTypes[StreetTypes["Avenue"] = 9] = "Avenue";
    StreetTypes[StreetTypes["Banan"] = 10] = "Banan";
    StreetTypes[StreetTypes["Bank"] = 11] = "Bank";
    StreetTypes[StreetTypes["Basin"] = 12] = "Basin";
    StreetTypes[StreetTypes["Bay"] = 13] = "Bay";
    StreetTypes[StreetTypes["Beach"] = 14] = "Beach";
    StreetTypes[StreetTypes["Bend"] = 15] = "Bend";
    StreetTypes[StreetTypes["Block"] = 16] = "Block";
    StreetTypes[StreetTypes["Boardwalk"] = 17] = "Boardwalk";
    StreetTypes[StreetTypes["Boulevard"] = 18] = "Boulevard";
    StreetTypes[StreetTypes["Boulevarde"] = 19] = "Boulevarde";
    StreetTypes[StreetTypes["Bowl"] = 20] = "Bowl";
    StreetTypes[StreetTypes["Brace"] = 21] = "Brace";
    StreetTypes[StreetTypes["Brae"] = 22] = "Brae";
    StreetTypes[StreetTypes["Break"] = 23] = "Break";
    StreetTypes[StreetTypes["Bridge"] = 24] = "Bridge";
    StreetTypes[StreetTypes["Broadway"] = 25] = "Broadway";
    StreetTypes[StreetTypes["Brow"] = 26] = "Brow";
    StreetTypes[StreetTypes["Bypass"] = 27] = "Bypass";
    StreetTypes[StreetTypes["Byway"] = 28] = "Byway";
    StreetTypes[StreetTypes["Canal"] = 29] = "Canal";
    StreetTypes[StreetTypes["Causeway"] = 30] = "Causeway";
    StreetTypes[StreetTypes["Centre"] = 31] = "Centre";
    StreetTypes[StreetTypes["Centreway"] = 32] = "Centreway";
    StreetTypes[StreetTypes["Chase"] = 33] = "Chase";
    StreetTypes[StreetTypes["Circle"] = 34] = "Circle";
    StreetTypes[StreetTypes["Circlet"] = 35] = "Circlet";
    StreetTypes[StreetTypes["Circuit"] = 36] = "Circuit";
    StreetTypes[StreetTypes["Circus"] = 37] = "Circus";
    StreetTypes[StreetTypes["Close"] = 38] = "Close";
    StreetTypes[StreetTypes["Cluster"] = 39] = "Cluster";
    StreetTypes[StreetTypes["Colonnade"] = 40] = "Colonnade";
    StreetTypes[StreetTypes["Common"] = 41] = "Common";
    StreetTypes[StreetTypes["Concourse"] = 42] = "Concourse";
    StreetTypes[StreetTypes["Connection"] = 43] = "Connection";
    StreetTypes[StreetTypes["Copse"] = 44] = "Copse";
    StreetTypes[StreetTypes["Corner"] = 45] = "Corner";
    StreetTypes[StreetTypes["Corso"] = 46] = "Corso";
    StreetTypes[StreetTypes["Course"] = 47] = "Course";
    StreetTypes[StreetTypes["Court"] = 48] = "Court";
    StreetTypes[StreetTypes["Courtyard"] = 49] = "Courtyard";
    StreetTypes[StreetTypes["Cove"] = 50] = "Cove";
    StreetTypes[StreetTypes["Crescent"] = 51] = "Crescent";
    StreetTypes[StreetTypes["Crest"] = 52] = "Crest";
    StreetTypes[StreetTypes["Cross"] = 53] = "Cross";
    StreetTypes[StreetTypes["Crossing"] = 54] = "Crossing";
    StreetTypes[StreetTypes["Crossroad"] = 55] = "Crossroad";
    StreetTypes[StreetTypes["Crossway"] = 56] = "Crossway";
    StreetTypes[StreetTypes["Cruiseway"] = 57] = "Cruiseway";
    StreetTypes[StreetTypes["Cul-De-Sac"] = 58] = "Cul-De-Sac";
    StreetTypes[StreetTypes["Cutting"] = 59] = "Cutting";
    StreetTypes[StreetTypes["Dale"] = 60] = "Dale";
    StreetTypes[StreetTypes["Dell"] = 61] = "Dell";
    StreetTypes[StreetTypes["Dene"] = 62] = "Dene";
    StreetTypes[StreetTypes["Deviation"] = 63] = "Deviation";
    StreetTypes[StreetTypes["Dip"] = 64] = "Dip";
    StreetTypes[StreetTypes["Distributor"] = 65] = "Distributor";
    StreetTypes[StreetTypes["Divide"] = 66] = "Divide";
    StreetTypes[StreetTypes["Dock"] = 67] = "Dock";
    StreetTypes[StreetTypes["Domain"] = 68] = "Domain";
    StreetTypes[StreetTypes["Drive"] = 69] = "Drive";
    StreetTypes[StreetTypes["Driveway"] = 70] = "Driveway";
    StreetTypes[StreetTypes["Edge"] = 71] = "Edge";
    StreetTypes[StreetTypes["Elbow"] = 72] = "Elbow";
    StreetTypes[StreetTypes["End"] = 73] = "End";
    StreetTypes[StreetTypes["Entrance"] = 74] = "Entrance";
    StreetTypes[StreetTypes["Esplanade"] = 75] = "Esplanade";
    StreetTypes[StreetTypes["Estate"] = 76] = "Estate";
    StreetTypes[StreetTypes["Estuary"] = 77] = "Estuary";
    StreetTypes[StreetTypes["Expressway"] = 78] = "Expressway";
    StreetTypes[StreetTypes["Extension"] = 79] = "Extension";
    StreetTypes[StreetTypes["Fairway"] = 80] = "Fairway";
    StreetTypes[StreetTypes["Fire Track"] = 81] = "Fire Track";
    StreetTypes[StreetTypes["Firebreak"] = 82] = "Firebreak";
    StreetTypes[StreetTypes["Fireline"] = 83] = "Fireline";
    StreetTypes[StreetTypes["Firetrack"] = 84] = "Firetrack";
    StreetTypes[StreetTypes["Firetrail"] = 85] = "Firetrail";
    StreetTypes[StreetTypes["Flat"] = 86] = "Flat";
    StreetTypes[StreetTypes["Follow"] = 87] = "Follow";
    StreetTypes[StreetTypes["Footway"] = 88] = "Footway";
    StreetTypes[StreetTypes["Ford"] = 89] = "Ford";
    StreetTypes[StreetTypes["Foreshore"] = 90] = "Foreshore";
    StreetTypes[StreetTypes["Formation"] = 91] = "Formation";
    StreetTypes[StreetTypes["Freeway"] = 92] = "Freeway";
    StreetTypes[StreetTypes["Front"] = 93] = "Front";
    StreetTypes[StreetTypes["Frontage"] = 94] = "Frontage";
    StreetTypes[StreetTypes["Gap"] = 95] = "Gap";
    StreetTypes[StreetTypes["Garden"] = 96] = "Garden";
    StreetTypes[StreetTypes["Gardens"] = 97] = "Gardens";
    StreetTypes[StreetTypes["Gate"] = 98] = "Gate";
    StreetTypes[StreetTypes["Gates"] = 99] = "Gates";
    StreetTypes[StreetTypes["Gateway"] = 100] = "Gateway";
    StreetTypes[StreetTypes["Glade"] = 101] = "Glade";
    StreetTypes[StreetTypes["Glen"] = 102] = "Glen";
    StreetTypes[StreetTypes["Grange"] = 103] = "Grange";
    StreetTypes[StreetTypes["Green"] = 104] = "Green";
    StreetTypes[StreetTypes["Ground"] = 105] = "Ground";
    StreetTypes[StreetTypes["Grove"] = 106] = "Grove";
    StreetTypes[StreetTypes["Gully"] = 107] = "Gully";
    StreetTypes[StreetTypes["Harbour"] = 108] = "Harbour";
    StreetTypes[StreetTypes["Heath"] = 109] = "Heath";
    StreetTypes[StreetTypes["Heights"] = 110] = "Heights";
    StreetTypes[StreetTypes["Highroad"] = 111] = "Highroad";
    StreetTypes[StreetTypes["Highway"] = 112] = "Highway";
    StreetTypes[StreetTypes["Hill"] = 113] = "Hill";
    StreetTypes[StreetTypes["Hollow"] = 114] = "Hollow";
    StreetTypes[StreetTypes["Hub"] = 115] = "Hub";
    StreetTypes[StreetTypes["Interchange"] = 116] = "Interchange";
    StreetTypes[StreetTypes["Intersection"] = 117] = "Intersection";
    StreetTypes[StreetTypes["Junction"] = 118] = "Junction";
    StreetTypes[StreetTypes["Key"] = 119] = "Key";
    StreetTypes[StreetTypes["Keys"] = 120] = "Keys";
    StreetTypes[StreetTypes["Landing"] = 121] = "Landing";
    StreetTypes[StreetTypes["Lane"] = 122] = "Lane";
    StreetTypes[StreetTypes["Laneway"] = 123] = "Laneway";
    StreetTypes[StreetTypes["Lees"] = 124] = "Lees";
    StreetTypes[StreetTypes["Line"] = 125] = "Line";
    StreetTypes[StreetTypes["Link"] = 126] = "Link";
    StreetTypes[StreetTypes["Little"] = 127] = "Little";
    StreetTypes[StreetTypes["Lookout"] = 128] = "Lookout";
    StreetTypes[StreetTypes["Loop"] = 129] = "Loop";
    StreetTypes[StreetTypes["Lower"] = 130] = "Lower";
    StreetTypes[StreetTypes["Mall"] = 131] = "Mall";
    StreetTypes[StreetTypes["Manor"] = 132] = "Manor";
    StreetTypes[StreetTypes["Meander"] = 133] = "Meander";
    StreetTypes[StreetTypes["Mears"] = 134] = "Mears";
    StreetTypes[StreetTypes["Mew"] = 135] = "Mew";
    StreetTypes[StreetTypes["Mews"] = 136] = "Mews";
    StreetTypes[StreetTypes["Mile"] = 137] = "Mile";
    StreetTypes[StreetTypes["Motorway"] = 138] = "Motorway";
    StreetTypes[StreetTypes["Mount"] = 139] = "Mount";
    StreetTypes[StreetTypes["Nook"] = 140] = "Nook";
    StreetTypes[StreetTypes["Outlet"] = 141] = "Outlet";
    StreetTypes[StreetTypes["Outlook"] = 142] = "Outlook";
    StreetTypes[StreetTypes["Parade"] = 143] = "Parade";
    StreetTypes[StreetTypes["Park"] = 144] = "Park";
    StreetTypes[StreetTypes["Parklands"] = 145] = "Parklands";
    StreetTypes[StreetTypes["Parkway"] = 146] = "Parkway";
    StreetTypes[StreetTypes["Part"] = 147] = "Part";
    StreetTypes[StreetTypes["Pass"] = 148] = "Pass";
    StreetTypes[StreetTypes["Passage"] = 149] = "Passage";
    StreetTypes[StreetTypes["Path"] = 150] = "Path";
    StreetTypes[StreetTypes["Pathway"] = 151] = "Pathway";
    StreetTypes[StreetTypes["Piazza"] = 152] = "Piazza";
    StreetTypes[StreetTypes["Pier"] = 153] = "Pier";
    StreetTypes[StreetTypes["Place"] = 154] = "Place";
    StreetTypes[StreetTypes["Plateau"] = 155] = "Plateau";
    StreetTypes[StreetTypes["Plaza"] = 156] = "Plaza";
    StreetTypes[StreetTypes["Pocket"] = 157] = "Pocket";
    StreetTypes[StreetTypes["Point"] = 158] = "Point";
    StreetTypes[StreetTypes["Port"] = 159] = "Port";
    StreetTypes[StreetTypes["Portal"] = 160] = "Portal";
    StreetTypes[StreetTypes["Promenade"] = 161] = "Promenade";
    StreetTypes[StreetTypes["Pursuit"] = 162] = "Pursuit";
    StreetTypes[StreetTypes["Quad"] = 163] = "Quad";
    StreetTypes[StreetTypes["Quadrangle"] = 164] = "Quadrangle";
    StreetTypes[StreetTypes["Quadrant"] = 165] = "Quadrant";
    StreetTypes[StreetTypes["Quay"] = 166] = "Quay";
    StreetTypes[StreetTypes["Quays"] = 167] = "Quays";
    StreetTypes[StreetTypes["Ramble"] = 168] = "Ramble";
    StreetTypes[StreetTypes["Ramp"] = 169] = "Ramp";
    StreetTypes[StreetTypes["Range"] = 170] = "Range";
    StreetTypes[StreetTypes["Reach"] = 171] = "Reach";
    StreetTypes[StreetTypes["Reserve"] = 172] = "Reserve";
    StreetTypes[StreetTypes["Rest"] = 173] = "Rest";
    StreetTypes[StreetTypes["Retreat"] = 174] = "Retreat";
    StreetTypes[StreetTypes["Return"] = 175] = "Return";
    StreetTypes[StreetTypes["Ride"] = 176] = "Ride";
    StreetTypes[StreetTypes["Ridge"] = 177] = "Ridge";
    StreetTypes[StreetTypes["Ridgeway"] = 178] = "Ridgeway";
    StreetTypes[StreetTypes["Right Of Way"] = 179] = "Right Of Way";
    StreetTypes[StreetTypes["Ring"] = 180] = "Ring";
    StreetTypes[StreetTypes["Rise"] = 181] = "Rise";
    StreetTypes[StreetTypes["Rising"] = 182] = "Rising";
    StreetTypes[StreetTypes["River"] = 183] = "River";
    StreetTypes[StreetTypes["Riverway"] = 184] = "Riverway";
    StreetTypes[StreetTypes["Riviera"] = 185] = "Riviera";
    StreetTypes[StreetTypes["Road"] = 186] = "Road";
    StreetTypes[StreetTypes["Roads"] = 187] = "Roads";
    StreetTypes[StreetTypes["Roadside"] = 188] = "Roadside";
    StreetTypes[StreetTypes["Roadway"] = 189] = "Roadway";
    StreetTypes[StreetTypes["Ronde"] = 190] = "Ronde";
    StreetTypes[StreetTypes["Rosebowl"] = 191] = "Rosebowl";
    StreetTypes[StreetTypes["Rotary"] = 192] = "Rotary";
    StreetTypes[StreetTypes["Round"] = 193] = "Round";
    StreetTypes[StreetTypes["Route"] = 194] = "Route";
    StreetTypes[StreetTypes["Row"] = 195] = "Row";
    StreetTypes[StreetTypes["Rue"] = 196] = "Rue";
    StreetTypes[StreetTypes["Run"] = 197] = "Run";
    StreetTypes[StreetTypes["Service Way"] = 198] = "Service Way";
    StreetTypes[StreetTypes["Shunt"] = 199] = "Shunt";
    StreetTypes[StreetTypes["Siding"] = 200] = "Siding";
    StreetTypes[StreetTypes["Slope"] = 201] = "Slope";
    StreetTypes[StreetTypes["Sound"] = 202] = "Sound";
    StreetTypes[StreetTypes["Spur"] = 203] = "Spur";
    StreetTypes[StreetTypes["Square"] = 204] = "Square";
    StreetTypes[StreetTypes["Stairs"] = 205] = "Stairs";
    StreetTypes[StreetTypes["State Highway"] = 206] = "State Highway";
    StreetTypes[StreetTypes["Steps"] = 207] = "Steps";
    StreetTypes[StreetTypes["Strand"] = 208] = "Strand";
    StreetTypes[StreetTypes["Street"] = 209] = "Street";
    StreetTypes[StreetTypes["Streets"] = 210] = "Streets";
    StreetTypes[StreetTypes["Strip"] = 211] = "Strip";
    StreetTypes[StreetTypes["Subway"] = 212] = "Subway";
    StreetTypes[StreetTypes["Tarn"] = 213] = "Tarn";
    StreetTypes[StreetTypes["Tarnice Way"] = 214] = "Tarnice Way";
    StreetTypes[StreetTypes["Terrace"] = 215] = "Terrace";
    StreetTypes[StreetTypes["Thoroughfare"] = 216] = "Thoroughfare";
    StreetTypes[StreetTypes["Throughway"] = 217] = "Throughway";
    StreetTypes[StreetTypes["Tollway"] = 218] = "Tollway";
    StreetTypes[StreetTypes["Top"] = 219] = "Top";
    StreetTypes[StreetTypes["Tor"] = 220] = "Tor";
    StreetTypes[StreetTypes["Towers"] = 221] = "Towers";
    StreetTypes[StreetTypes["Track"] = 222] = "Track";
    StreetTypes[StreetTypes["Trail"] = 223] = "Trail";
    StreetTypes[StreetTypes["Trailer"] = 224] = "Trailer";
    StreetTypes[StreetTypes["Triangle"] = 225] = "Triangle";
    StreetTypes[StreetTypes["Trunkway"] = 226] = "Trunkway";
    StreetTypes[StreetTypes["Turn"] = 227] = "Turn";
    StreetTypes[StreetTypes["Twist"] = 228] = "Twist";
    StreetTypes[StreetTypes["Underpass"] = 229] = "Underpass";
    StreetTypes[StreetTypes["Upper"] = 230] = "Upper";
    StreetTypes[StreetTypes["Vale"] = 231] = "Vale";
    StreetTypes[StreetTypes["Viaduct"] = 232] = "Viaduct";
    StreetTypes[StreetTypes["View"] = 233] = "View";
    StreetTypes[StreetTypes["Villas"] = 234] = "Villas";
    StreetTypes[StreetTypes["Vista"] = 235] = "Vista";
    StreetTypes[StreetTypes["Wade"] = 236] = "Wade";
    StreetTypes[StreetTypes["Walk"] = 237] = "Walk";
    StreetTypes[StreetTypes["Walkway"] = 238] = "Walkway";
    StreetTypes[StreetTypes["Waterway"] = 239] = "Waterway";
    StreetTypes[StreetTypes["Way"] = 240] = "Way";
    StreetTypes[StreetTypes["Wharf"] = 241] = "Wharf";
    StreetTypes[StreetTypes["Woods"] = 242] = "Woods";
    StreetTypes[StreetTypes["Wynd"] = 243] = "Wynd";
    StreetTypes[StreetTypes["Yard"] = 244] = "Yard";
})(StreetTypes || (StreetTypes = {}));
//# sourceMappingURL=Address.js.map